import { Component, Input, OnInit } from '@angular/core';
import { SmsHistorySortInput, SortEnumType } from '../../../../../../graphql';
import { Page } from '../../../../../core/components/table-footer-paging/table-footer-paging.component';
import { FeatureService, PermissionService } from '../../../../../core/services/permission';
import { SmsHistoryItem, SmsService } from '../../../../../core/services/sms.service';
import { UserService } from '../../../../../core/services/user';
import { Contact } from '../../../../../data/models';
import { SortEvent } from '../../../../../data/models/datatable.model';
import { SharedDataService } from '../../../../../data/services/shared-data.service';
import { ContactsService } from '../../../contacts.service';
import { BxUnverifiedAlertService } from './../../../../../core/services/bx-unverified-alert.service';

@Component({
    selector: 'app-contact-sms',
    templateUrl: './contact-sms.component.html',
    standalone: false,
})
export class ContactSMSComponent implements OnInit {
    @Input() contact!: Contact;
    rows: SmsHistoryItem[] = [];
    isLoading = false;
    page = new Page();
    sortBy: SmsHistorySortInput = { dateSent: SortEnumType.Asc };
    public showCreate = false;

    constructor(
        private contactsService: ContactsService,
        private sharedData: SharedDataService,
        private bxUnverifiedAlertService: BxUnverifiedAlertService,
        private smsService: SmsService,
        private readonly userService: UserService,
        private readonly permissionService: PermissionService,
        private readonly featureService: FeatureService
    ) {}

    ngOnInit() {
        this.setDefaults();
        this.loadData();
        this.showCreate =
            this.permissionService.isAvailable('contacts.maintain-contacts.send-contact-sms') &&
            this.featureService.isAvailable('sms-features') &&
            this.userService.isSmsEnabled;
    }

    newSMS() {
        if (!this.sharedData.UserData.identityInfo.email_verified) {
            this.bxUnverifiedAlertService.trigger(this.sharedData.UserData.user);
            return;
        }

        this.contactsService.smsContact(this.contact).subscribe(() => {
            this.loadData();
        });
    }

    // ngx-datatable functions
    setPage(pageNumber: number) {
        this.page.pageNumber = pageNumber;
        this.loadData();
    }

    pageLimit(event: { target: Node }) {
        this.page.size = Number.parseInt(event.target.textContent!);
        this.page.pageNumber = 0;
        this.loadData();
    }

    setDefaults() {
        this.page.pageNumber = 0;
        this.page.size = 10;

        this.sortBy = { dateSent: SortEnumType.Asc };
    }

    loadData() {
        this.isLoading = true;

        this.smsService
            .getSmsHistories({
                skip: this.page.pageNumber * this.page.size,
                take: this.page.size,
                order: [this.sortBy],
                where: { iD_Reference: { eq: this.contact.ID_Contact } },
            })
            .subscribe((result) => {
                this.page.totalElements = result.data.smsHistories?.totalCount ?? 0;
                this.rows = result.data.smsHistories?.items ?? [];
                this.isLoading = false;
            });
    }

    onSort(event: SortEvent<SmsHistoryItem>) {
        this.sortBy = { [event.sorts[0].prop]: event.sorts[0].dir === 'desc' ? SortEnumType.Desc : SortEnumType.Asc };
        this.loadData();
    }
}
